import React, { useContext } from 'react';
import { Navigate, Outlet, useLocation, useParams } from 'react-router-dom';
import AuthContext from '../context/AuthContext';

const PrivateRoute = () => {
  const { user, loading } = useContext(AuthContext);
  const { branch } = useParams();
  const location = useLocation();

  if (loading) {
    // Optionally, show a spinner or loading indicator here
    return <div>Loading...</div>;
  }

  if (!user) {
    // Redirect to the correct branch login
    return <Navigate to={`/login/${branch || 'branch1'}`} state={{ from: location }} replace />;
  }
  return <Outlet />;
};

export default PrivateRoute;
